var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 23,
    viewBox: "0 0 44 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.31445 10.2622C1.48603 10.2622 0.814453 10.9338 0.814453 11.7622C0.814453 12.5906 1.48603 13.2622 2.31445 13.2622V10.2622ZM43.3751 12.8229C43.9609 12.2371 43.9609 11.2873 43.3751 10.7015L33.8292 1.15561C33.2434 0.569819 32.2936 0.569819 31.7079 1.15561C31.1221 1.74139 31.1221 2.69114 31.7079 3.27693L40.1931 11.7622L31.7079 20.2475C31.1221 20.8333 31.1221 21.783 31.7079 22.3688C32.2936 22.9546 33.2434 22.9546 33.8292 22.3688L43.3751 12.8229ZM2.31445 13.2622H42.3145V10.2622H2.31445V13.2622Z",
    fill: "#DBDBDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.35f36030a65c79e87f25b9f24ffa41d8.svg";
export { ForwardRef as ReactComponent };